import React from "react";
import PropTypes from "prop-types";

import TradingAddressForm from "../../../../components/lsp/tradingaddress/TradingAddressForm";

const TradingAddress = ({ handleChange, data, states, cities }) => {
  return (
    <div className="formgrid grid">
      <div className="field">
        <p className="general-info">Trading Address</p>
      </div>
      <TradingAddressForm
        handleChange={handleChange}
        data={data}
        states={states}
        cities={cities}
        isEdit={true}
      />
    </div>
  );
};
TradingAddress.propTypes = {
  data: PropTypes.object,
  handleChange: PropTypes.func,
  states: PropTypes.array,
  cities: PropTypes.array,
};
export default TradingAddress;
